import React from 'react';
import _ from 'lodash';
import { SessionListing } from '../common/types.js';
import TimeFromNow from './TimeFromNow.jsx';
import { getHashTags } from '../common/lib.js';

export default function SessionsGrid(props: { sessions: SessionListing[] }) {
  return (
    <div className="sessions-grid">
      {props.sessions.map(session => (
        <SessionUIItem session={session} />
      ))}
    </div>
  );
}

function SessionUIItem(props: { session: SessionListing }) {
  const { head, publication } = props.session;
  const href = `/s/${head.author}/${head.handle}`;

  const tags = getHashTags(head);
  const tagsStr = _.truncate(_.take(tags, 3).join(' '), { length: 30 });

  function openSession() {
    window.location.href = href;
  }

  return (
    <div className="session" tabIndex={0} onClick={openSession}>
      <div className="session-inner-wrapper">
        <a className="cover-container" href={href}>
          <img className="cover" src={`/session-cover?id=${head.id}`} />
          {head.isClip && <div className="clip-banner">CLIP</div>}
          <div className="duration">{formatTimeSeconds(head.duration)}</div>
        </a>
        <div className="avatar-and-content">
          <div className="avatar-container">
            <img className="avatar" src={`/avatar?username=${head.author}`} />
          </div>
          <div className="content">
            <h3>
              <a href={href}>
                {head.title || 'Untitled'} <span className="tags">{tagsStr}</span>
              </a>
            </h3>
            <div className="handle">
              {head.author}
              <span className="no-select"> </span>/<span className="no-select"> </span>
              {head.handle}
            </div>
            <div className="footer">
              {publication.views > 0 && (
                <>
                  <span className="stats">
                    {publication.views} {pluralize(publication.views, 'view', 'views')}
                  </span>
                  <span> • </span>
                </>
              )}
              {publication.likes > 0 && (
                <>
                  <span className="stats">
                    {publication.likes} {pluralize(publication.views, 'like', 'likes')}
                  </span>
                  <span> • </span>
                </>
              )}
              <TimeFromNow timestamp={publication.publishTimestamp} />
            </div>
          </div>
          {/*<div className="stats">{publication.likes} likes</div>*/}
        </div>
      </div>
    </div>
  );
}

function formatTimeSeconds(time: number, full: boolean = false): string {
  const h = Math.floor(time / 3600);
  const m = Math.floor((time / 60) % 60);
  const s = Math.floor(time % 60);
  const hStr = String(h).padStart(2, '0');
  const mStr = String(m).padStart(2, '0');
  const sStr = String(s).padStart(2, '0');

  return h || full ? `${hStr}:${mStr}:${sStr}` : `${mStr}:${sStr}`;
}

function pluralize(count: number, singularForm: string, pluralForm: string) {
  return count > 1 ? pluralForm : singularForm;
}
